import { createContext, useContext, useState } from "react";
import { Spinner } from "react-bootstrap";

const LoadingContext = createContext();

export const useLoading = () => useContext(LoadingContext);

export const LoadingProvider = ({ children }) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ isLoading, setLoading }}>
      <style>
        {`
          /*
            The overlay is held invisible for a beat before it fades in. It
            covers the whole viewport in a dark blur, so throwing it up for a
            request that answers in ~100ms reads as the page flashing on load
            rather than as loading. Anything slow enough to be worth a spinner
            still gets one.

            Only the paint is delayed — the element is in the DOM from the
            first moment, so it keeps blocking clicks the whole time and a
            double-submit still can't get through.
          */
          .ot-page-loader {
            opacity: 0;
            animation: otPageLoaderIn 160ms ease-out 250ms forwards;
          }

          @keyframes otPageLoaderIn {
            to { opacity: 1; }
          }

          @media (prefers-reduced-motion: reduce) {
            .ot-page-loader { animation-duration: 1ms; }
          }
        `}
      </style>
      {children}
      {isLoading && (
        <div
          className="ot-page-loader"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(4px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spinner animation="border" variant="light" />
        </div>
      )}
    </LoadingContext.Provider>
  );
};
